export default __webpack_public_path__ + "static/media/danatoken-right-bg.698ee381.png";